<template>
<main-content with_go_back_bar>
    <div v-if="$can('manage-category', 'ticket') && status === 'success'">
        <ticket-header
            v-if="ticket"
            :ticketCategories="categories"
            :ticket.sync="ticket"
        >
        </ticket-header>
    </div>
    <div class="kt-grid__item kt-grid__item--fluid kt-app__content" id="kt_chat_content" v-if="ticket && status ==='success'">
        <div class="kt-chat">
            <div class="kt-portlet kt-portlet--head-lg kt-portlet--last">
                <div class="kt-portlet__body">
                    <div v-if="$can('read', 'ticket')">
                        <admin-seen-ticket
                                v-if="ticket.seen_by"
                                :seenBy="ticket.seen_by"
                                :related_user="ticket.related_user">
                        </admin-seen-ticket>
                    </div>
                    <div class="line-divider mt-2 mb-3" v-if="ticket.seen_by"></div>
                    <div class="kt-scroll kt-scroll--pull" data-mobile-height="300">
                        <div class="kt-chat__messages" v-bind:key="index"
                            v-for="(comment, index) in ticket.comments"
                        >
                            <div v-if="comment.created_by == ticket.created_by ||
                             (ticket.created_by != ticket.created_for && comment.created_by != ticket.created_for)"
                                 class="kt-chat__message"
                            >
                                <div class="kt-chat__text kt-bg-light-success col-lg-6 col-md-6 col-sm-6 special-chat"
                                     style="white-space: pre-line"
                                >
                                    <kt-row>
                                        <kt-col lg="6" md="6" sm="12">
                                            <i :class="'mr-2 ' + icon(comment)"></i>
                                            <a v-if="($can('read-sensitive-info', 'user')) && comment.is_user"
                                               :href="'/users/' +  comment.user_id + '/details'" target="_blank"
                                               style="display: inline"
                                               :id="'user_name_' + index"
                                            >
                                                <span>{{ comment.user_name }}</span>
                                            </a>
                                            <span v-else-if="comment.is_user">{{ comment.user_name }}</span>
                                            <span v-else-if="!comment.is_user && comment.admin_name">
                                                {{ comment.admin_name }}
                                            </span>
                                            <span v-else> {{ $t('label.ticket_admin') }} </span>
                                        </kt-col>
                                        <kt-col lg="6" md="6" sm="12" class="kt-margin-t-5-mobile">
                                            <span style="text-align: left; float: left">{{comment.date}}</span>
                                        </kt-col>
                                    </kt-row>
                                    <div class="line-divider mt-2 mb-3"></div>
                                    <span v-html="comment.content"></span>
                                    <br>
                                    <a v-if="comment.file" :href="comment.file" class="mt-2">
                                        {{ $t('label.comment_file') }}
                                    </a>
                                    <br>
                                    <div v-if="comment.signature" v-html="comment.signature"
                                         class="kt-margin-t-100-desktop kt-margin-t-50-tablet-and-mobile"
                                    >
                                    </div>
                                </div>
                                <div class="mt-2" v-if="index == (ticket.comments.length) - 1">
                                    <a v-show="$can('read', 'ticket') &&
                                     ticket.created_for != comment.created_by"
                                       href="#" @click.prevent="deleteComment(comment.id, 'deleteBtn1')"
                                       :title="$t('btn.delete')"
                                       id="deleteBtn1"
                                       class="btn btn-sm btn-clean btn-icon btn-icon-sm">
                                        <i class="fa fa-trash"></i>
                                    </a>
                                    <a v-show="$can('read', 'ticket') &&
                                     ticket.created_for != comment.created_by"
                                       href="#" @click.prevent="editComment(comment.id, comment.content)"
                                       :title="$t('btn.edit')"
                                       class="btn btn-sm btn-clean btn-icon btn-icon-sm">
                                        <i class="fa fa-edit"></i>
                                    </a>
                                </div>
                            </div>
                            <div v-else class="kt-chat__message kt-chat__message--right"
                                 style="white-space: pre-line"
                            >
                                <div class="kt-chat__text kt-bg-light-brand col-lg-6 col-md-6 col-sm-6 special-chat"
                                     style="text-align: right"
                                >
                                    <kt-row>
                                        <kt-col lg="6" md="6" sm="12">
                                            <i :class="'mr-2 ' + icon(comment)"></i>
                                            <a v-if="($can('read-general-info', 'user')) && comment.is_user"
                                               :href="'/users/' +  comment.user_id + '/details'" target="_blank"
                                               style="display: inline"
                                            >
                                                <span>{{ comment.user_name }}</span>
                                            </a>
                                            <span v-else-if="comment.is_user">{{ comment.user_name }}</span>
                                            <span class="text-nowrap" v-else-if="!comment.is_user && comment.admin_name">
                                                {{ comment.admin_name }}
                                            </span>
                                            <span v-else> {{ $t('label.ticket_admin') }} </span>
                                        </kt-col>
                                        <kt-col lg="6" md="6" sm="12" class="mt-sm-2">
                                            <span style="text-align: left; float: left">{{comment.date}}</span>
                                        </kt-col>
                                    </kt-row>
                                    <div class="line-divider mt-2 mb-3"></div>
                                    <span v-html="comment.content"></span>
                                    <br>
                                    <a v-if="comment.file" :href="comment.file" class="mt-2" target="_blank">
                                        {{ $t('label.comment_file') }}
                                    </a>
                                    <br>
                                    <div v-if="comment.signature" v-html="comment.signature"
                                         class="kt-margin-t-100-desktop kt-margin-t-50-tablet-and-mobile"
                                    >
                                    </div>
                                </div>
                                <div class="mt-2" v-if="index == (ticket.comments.length) - 1">
                                    <a v-show="$can('comment-delete', 'ticket') &&
                                     ticket.created_for != comment.created_by"
                                       href="#" @click.prevent="deleteComment(comment.id, 'deleteBtn')"
                                       :title="$t('btn.delete')"
                                       id="deleteBtn"
                                       class="btn btn-sm btn-clean btn-icon btn-icon-sm">
                                        <i class="fa fa-trash"></i>
                                    </a>
                                    <a v-show="$can('read', 'ticket') &&
                                     ticket.created_for != comment.created_by"
                                       href="#" @click.prevent="editComment(comment.id, comment.content)"
                                       :title="$t('btn.edit')"
                                       class="btn btn-sm btn-clean btn-icon btn-icon-sm">
                                        <i class="fa fa-edit"></i>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <form id="answer">
                    <div class="kt-portlet__foot" >
                        <div class="kt-chat__input">
                            <div class="kt-chat__editor">
                                <label for="userContent">
                                    {{ $t('label.content') }}
                                </label>
                                <ckeditor
                                    v-if="$can('read', 'ticket')"
                                    id="userContent"
                                    name="content"
                                    v-model="commentContent"
                                    :editor="editor"
                                    :config="editorConfig"
                                    tag-name="textarea"
                                >
                                </ckeditor>
                                <textarea
                                    v-else
                                    id="userContent"
                                    style="height: 50px"
                                    name="content"
                                    :placeholder="$t('label.write_something')"
                                    v-model="commentContent"
                                ></textarea>
                            </div>
                            <kt-form-group class="mt-5">
                                <kt-form-label>
                                    {{ $t('label.file_attaching') }}
                                </kt-form-label>
                                <kt-form-label for="file" class="d-block btn btn-secondary btn-wide label-file">
                                    <kt-icon type="fa" name="paperclip"></kt-icon>
                                    {{ $t('label.select_file') }}
                                </kt-form-label>
                                <input
                                    @change="processFile"
                                    type="file"
                                    class="custom-file-upload"
                                    name="file"
                                    id="file"
                                    accept="image/png,.jpg,.jpeg,.zip"
                                />
                            </kt-form-group>
                            <ul class="list-group mb-3">
                                <li class="border-0 px-0 py-1 list-group-item">
                                    {{ $t('label.comment_files_allowed_format') }}
                                </li>
                            </ul>
                            <div class="kt-chat__toolbar">
                                <div class="kt_chat__tools">
                                    <!-- <a href="#"><i class="flaticon2-link"></i></a> -->
                                </div>
                                <div class="kt_chat__actions d-flex align-items-center">
                                    <button v-if="!isEditing" type="button" @click="submitComment"
                                        class="btn btn-brand btn-md btn-upper btn-bold kt-chat__reply"
                                        id="replyBtn">
                                {{ $t('btn.reply') }}
                                    </button>
                                    <button v-else type="button" @click="updateComment"
                                            class="btn btn-brand btn-md btn-upper btn-bold kt-chat__reply"
                                            id="editBtn">
                                {{ $t('btn.edit') }}
                                    </button>
                                    <button v-if="isEditing" type="button" @click="cancelEdit"
                                            class="btn btn-secondary btn-md btn-upper btn-bold kt-chat__reply ml-2">
                                {{ $t('btn.cancel') }}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</main-content>
</template>


<script>
import mainContent from '@/components/main-content'
import { mapGetters } from 'vuex'
import $ from 'jquery'
import { i18n } from '@/plugins/i18n'
import { KTApp } from '@/plugins/core/app'
import {statusStr ,ticketStatus} from '@/constants/ticketStatus'
import ticketHeader from './components/ticket-header'
import adminSeenTicket from './components/ticket-seen'
import toastr from "toastr";
import CKEditor from "@ckeditor/ckeditor5-vue2";
import ClassicEditor from "@ckeditor/ckeditor5-editor-classic/src/classiceditor";
import {editorConfig} from "@/constants/ckeditorConfigs";
import Label from "@/components/elements/form/check/label.vue";
import _ from "lodash";

export default {
    name: 'comments',
    data() {
        return {
            commentContent: '',
            comment_id: null,
            isEditing: false,
            ticketStatus: ticketStatus,
            editor: ClassicEditor,
            editorConfig: editorConfig,
            file: null
        }
    },
    components: {
        mainContent,
        'admin-seen-ticket': adminSeenTicket,
        ticketHeader,
        ckeditor: CKEditor.component
    },
    beforeRouteEnter (to, from, next) {
        next(vm => {
            vm.$store.dispatch('ticket/find', vm.$route.params.hashid)
        })
    },
    computed: {
        ...mapGetters('ticket', [
            'ticket',
            'status',
            'categories'
        ]),
        toastr() {
            toastr.options = {
                closeButton: true,
                positionClass: "toast-bottom-center",
                preventDuplicates: false,
                rtl: false
            }

            return toastr
        },
    },
    mounted() {
        this.$store.dispatch('badgeCounter/countData')
        this.$store.dispatch('badgeCounter/countUserTickets')
        this.$store.dispatch('ticket/fetchCategories')
    },
    methods: {
        cancelEdit() {
        this.isEditing = false;
        this.commentContent = '';
        this.comment_id = null;
        document.querySelector('#userContent').value = null;
    },
        submitComment() {
            let btn = $('#replyBtn')

            if(this.commentContent == null || this.commentContent.length == 0) {
                this.toastr.error('فیلد توضیحات الزامی می باشد!');
                return
            }

            let data = {
                ticket_id : this.$route.params.hashid,
                content: this.commentContent,
            }

            if (this.file) {
                data.file = this.file
            }

            if (this.file) {
                data.file = this.file
            }

            KTApp.progress(btn)

            this.commentContent = ''
            this.$store.dispatch('ticket/submitComment', data)
                .then((response) => {
                    this.$store.dispatch('badgeCounter/countData')
                })
                .finally(() => {
                    KTApp.unprogress(btn)
                })
        },
        deleteComment(hashid, btn_id) {
            if(confirm(i18n.t('confirm.delete_comment'))) {
                $('#' + btn_id).addClass('disabled');
                this.$store.dispatch('ticket/deleteComment', hashid).then(() => {
                    this.$store.dispatch('ticket/find', this.$route.params.hashid)
                    this.commentContent = null
                })
            }
            this.cleanAreaText()
        },
        cleanAreaText() {
            $('#userContent').html(null)
            document.querySelector('#userContent').value = null
        },
        editComment(hashid, content) {
            this.isEditing = true;
            this.comment_id = hashid;
            this.commentContent = content;
            document.querySelector('#userContent').value = content;
        },
        updateComment() {
        let btn = $('#editBtn');
        let last_comment_index = this.ticket.comments.length - 1;
        let data = {
            ticket_id: this.$route.params.hashid,
            comment_id: this.comment_id,
            content: this.commentContent
        };

        if (this.file) {
            data.file = this.file;
        }

        KTApp.progress(btn);

        this.$store.dispatch('ticket/updateComment', data)
            .then(() => {
                this.ticket.comments[last_comment_index].content = document.querySelector('#userContent').value
                this.$store.dispatch('badgeCounter/countData');
                this.isEditing = false;
                this.commentContent = '';
                this.comment_id = null;
            })
            .finally(() => {
                document.querySelector('#userContent').value = null;
                KTApp.unprogress(btn);
            });
        },
        icon(comment) {
            if (comment.is_user)
                return 'fas fa-user'
            else
                return 'fas fa-headset'
        },
        processFile(e) {
            this.file = event.target.files[0]
            this.validateSize(event.target)
            this.validateFormat(event.target)
        },
        validateSize(file) {
            var FileSize = file.files[0].size / 1024 / 1024; // in MB
            if (FileSize > 1) {
                alert(i18n.t('label.comment_files_allowed_size'));
                this.file = ''
                $(file).val('');
            } else {

            }
        },
        validateFormat(file) {
            let jq_file = $(file);
            let file_name = jq_file.val();
            let extension = file_name.replace(/^.*\./, '');
            if (extension === file_name) {
                extension = '';
            } else {
                extension = extension.toLowerCase();
            }

            switch (extension) {
                case 'jpg':
                case 'jpeg':
                case 'png':
                case 'zip':
                    break;
                default:
                    alert(i18n.t('authenticate.input_format_err'));
                    this.file = ''
                    $(file).val('');
            }
        }
    }
}
</script>

<style>
    span {
        word-break: break-word;
    }
.kt-chat__message--right {
    word-break: break-all;
}
a.disabled {
    opacity: 0.5;
    pointer-events: none;
    cursor: default;
}

@media (min-width:1024px)  {
    .special-chat {
        padding: 1rem !important;
    }
}

</style>
